import React from "react";
import dayjs from "dayjs";
import { SubscriptionContext } from "../..";

const ConfirmationDetail = ({ property, value }) =>
  property &&
  value && (
    <span>
      <b>{property}</b>: {value}
    </span>
  );

const Confirmation = () => {
  const { pendingApplication = {} } = React.useContext(SubscriptionContext);

  const {
    id: applicationId,
    contact = {},
    details = {},
    submission = {},
  } = pendingApplication;

  const { email, name } = contact;
  const { rateRequested } = details;
  const { timestamp } = submission;

  return (
    <>
      <p className="m-0 max-w-[600px] text-sm font-semibold text-slate-600">
        Your application for a discount is under review, a member of the Dr
        Frost team will be in touch.
      </p>
      <div className="-mt-2 flex flex-col text-xs text-slate-400">
        <ConfirmationDetail property="Application ID" value={applicationId} />
        <ConfirmationDetail property="Contact email" value={email} />
        <ConfirmationDetail property="Contact name" value={name} />
        <ConfirmationDetail
          property="Date submitted"
          value={
            timestamp ? dayjs(timestamp * 1000).format("DD/MM/YYYY") : null
          }
        />
        <ConfirmationDetail
          property="Discount requested"
          value={
            [0, 0.25, 0.5, 0.75].includes(rateRequested)
              ? `${(1 - rateRequested) * 100}%`
              : null
          }
        />
      </div>
    </>
  );
};

export default Confirmation;
